import React from "react";
import "./Techstacks.css";
import { FaReact, FaNodeJs, FaAws,FaJava } from "react-icons/fa";
import {
  SiRedux,
  SiHtml5,
  SiMaterialui,
  SiExpress,
  SiRedis,
  SiTailwindcss,
  SiNetlify
} from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { DiCss3, DiMongodb } from "react-icons/di";
import { SiJavascript, SiSwagger ,SiSpring,SiHibernate,SiSpringboot,SiPostman} from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap, BsWordpress } from "react-icons/bs";

export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different">Skills</h2>
        <div className="techsection">
          <div>
            <SiJavascript />
            <h5>Javascript</h5>
          </div>
          <div>
            <SiHtml5 />
            <h5>HTML</h5>
          </div>
          <div>
            <DiCss3 />
            <h5>CSS</h5>
          </div>
          <div>
            <SiHibernate/>
            <h5>Hibernate</h5>
          </div>
          <div>
            <FaJava />
            <h5>Java</h5>
          </div>
          <div>
            <SiSpring />
            <h5>Spring</h5>
          </div>

          <div>
            <GrMysql />
            <h5>SQL</h5>
          </div>

          <div>
            <SiPostman />
            <h5>Postman</h5>
          </div>
          <div>
            <SiSpringboot/>
            <h5>SpringBoot</h5>
          </div>
          <div>
            <SiNetlify />
            <h5>Netlify</h5>
          </div>
          <div>
            <VscGithub />
            <h5>Github</h5>
          </div>
          <div>
            <SiSwagger />
            <h5>Swagger</h5>
          </div>
        </div>
      </div>
    </>
  );
};